// extracted by mini-css-extract-plugin
export default {"input_phone":"Phone_input_phone__M3+zu"};